import "@Styles/mandate.css";
import React from 'react';
import arrowleft from "@Images/NewUI/Vector.png";
import { SAFETY_COVERAGE } from "../Common/constant";

// PDF in public directory served at root path in Vite
const insurancePdf = "/insurancetc.pdf";

const SafetyCoverage = ({ onBack }) => {
  return (
    <div className="">
      <div className="sc-header">
      <div style={{paddingBottom: "18px" , margin:"0 auto"}} className="customheading maxWidth450 minwid320 shadowline sticky-header">
           <img style={{cursor:"pointer", marginLeft:"20px"}} className="customimgfix" src={arrowleft} onClick={() => {
             window.location.href="/profile_menu";
             }} />
            <span style={{ paddingLeft:"45px", color:'#152745', fontWeight:'700', fontSize:'30px'}}>{SAFETY_COVERAGE}</span>
           </div>
      </div>

      <div className="sc-table-wrapper  perp-max-width">
        <table className="sc-table ">
          <thead>
            <tr>
              <th>Sanction Amount</th>
              <th>Premium</th>
              <th>Coverage</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>500 - 5,000</td><td>10</td><td>50,000</td></tr>
            <tr><td>5,001 - 19,999</td><td>20</td><td>1,00,000</td></tr>
            <tr><td>20,000 - 29,999</td><td>41</td><td>2,00,000</td></tr>
            <tr><td>30,000 - 39,999</td><td>61</td><td>3,00,000</td></tr>
            <tr><td>40,000 - 49,999</td><td>82</td><td>4,00,000</td></tr>
            <tr><td>50,000 - 59,999</td><td>102</td><td>5,00,000</td></tr>
            <tr><td>60,000 - 69,999</td><td>122</td><td>6,00,000</td></tr>
            <tr><td>70,000 - 79,999</td><td>143</td><td>7,00,000</td></tr>
            <tr><td>80,000 - 89,999</td><td>163</td><td>8,00,000</td></tr>
            <tr><td>90,000 - 99,999</td><td>184</td><td>9,00,000</td></tr>
            <tr><td>1,00,000+</td><td>204</td><td>10,00,000</td></tr>
          </tbody>
        </table>
      </div>

      <div className="sc-note perp-max-width scnotify">
        <p><strong>Note -</strong> Coverage period 45 days (inc taxes)</p>
      </div>

      <div className="sc-steps perp-max-width">
        <h3>How to Avail Insurance with Your PayMe Loan</h3>
        <ol>
          <li>
            <strong>Apply for a Loan:</strong> Choose and apply for any loan from PayMe.
          </li>
          <li>
            <strong>Premium Deduction:</strong> The insurance premium will be deducted along with the processing fee from your loan amount.
          </li>
          <li>
            <strong>Policy Generation:</strong> Once the loan is credited to your bank account, your policy will be generated and sent to you via email.
          </li>
          <li>
            <strong>Claiming Your Insurance:</strong> To make a claim, visit the Care Health website and proceed with your policy number.
          </li>
        </ol>
      </div>

      <div className="sc-footer-note perp-max-width proceedtotakelona600">
        <p>Stay protected while securing your financial needs with PayMe!</p>
      </div>

      <div className="sc-tnc perp-max-width">
        <h4>Terms & Conditions</h4>
        {/* <iframe
    src={insurancePdf}
    width="100%"
    height="600px"
    style={{ border: "none", marginTop: "20px" }}
    title="Terms and Conditions PDF"
  ></iframe> */}
  <embed
    src={insurancePdf}
    type="application/pdf"
    width="100%"
    height="600px"
  />
      </div>
    </div>
  );
};

export default SafetyCoverage;
